module.exports = __webpack_public_path__ + "static/media/ovest4.e2cba17e.svg";